import React, { memo, useEffect, useState } from 'react';
import { Modal, Button, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';

const LostStillageModal = ({ showModal, setShowModal, modalData, onUpdateStillage }) => {
    const [comment, setComment] = useState(() => modalData?.stillageComment ?? '');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setComment(modalData?.stillageComment ?? '');
    }, [modalData]);

    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            centered
            size="xl"
            animation={false}
            scrollable
            restoreFocus={false}
            enforceFocus={false}
            autoFocus={false}>
            <Modal.Header>
                <Modal.Title>Mark Stillage {modalData?.stillageNo} as {modalData?.lostStillage ? 'Active' : 'Lost'}?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Please enter a reason below</p>
                <FormControl
                    as="textarea"
                    rows={4}
                    value={comment}
                    onChange={e => setComment(e.target.value)} />
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={loading}
                    variant="primary"
                    onClick={() => onUpdateStillage(comment, !modalData?.lostStillage, modalData?.stillageId, setLoading)}
                >Save</Button>
                <Button disabled={loading} variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

LostStillageModal.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    modalData: PropTypes.object,
    onUpdateStillage: PropTypes.func
};

export default memo(LostStillageModal);